import { Reveal } from "@/components/Motion";

const Block = ({ title, children }) => (
  <Reveal className="mb-10">
    <h2 className="font-serif text-2xl md:text-3xl text-gold mb-4">{title}</h2>
    <div className="text-white/60 font-light leading-relaxed space-y-3">{children}</div>
  </Reveal>
);

export default function CGV() {
  return (
    <div className="pt-32 pb-24" data-testid="cgv-page">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <Reveal>
          <p className="text-xs uppercase tracking-luxe text-gold mb-6">Conditions Générales de Vente</p>
          <h1 className="font-serif text-5xl md:text-6xl text-white mb-4">CGV</h1>
          <p className="text-white/50 text-sm mb-14">
            SYNERGIE VITA HOLDING — Académie AETHERIS · En vigueur au 27 août 2026
          </p>
        </Reveal>

        <Block title="Article 1 — Objet">
          <p>Les présentes CGV régissent les ventes de produits numériques et prestations de coaching par SYNERGIE VITA HOLDING (ci-après « le Vendeur ») via le site https://serenite-essence.fr.</p>
        </Block>

        <Block title="Article 2 — Produits et services">
          <p><span className="text-white">2.1 Kit Digital Premium</span> (67,00 € TTC) : ensemble de ressources numériques livrées par email sous 24h après paiement.</p>
          <p><span className="text-white">2.2 Coaching Élite</span> (1 950,00 € TTC) : 12 séances de coaching individuel d'une heure, par visioconférence.</p>
          <p><span className="text-white">2.3 Coaching Souverain</span> : 24 séances de coaching individuel d'une heure, par visioconférence. Deux modalités de paiement : comptant <strong>3 200,00 € TTC</strong> (économie de 300 €) ou fractionné <strong>4 × 875 €/mois</strong> = 3 500,00 € TTC via abonnement Stripe (annulation automatique après le 4ᵉ prélèvement).</p>
        </Block>

        <Block title="Article 3 — Commande et paiement">
          <p>Le paiement est sécurisé par Stripe Inc. Le Vendeur ne stocke aucune donnée bancaire. Le paiement est exigible comptant à la commande, ou selon le plan fractionné sélectionné.</p>
        </Block>

        <Block title="Article 4 — Droit de rétractation">
          <p>Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation ne s'applique pas aux contenus numériques fournis sur support immatériel dont l'exécution a commencé après accord exprès du consommateur.</p>
          <p>Pour les prestations de coaching : le délai de rétractation de 14 jours s'applique à compter de la date de conclusion du contrat, sauf si la prestation a déjà commencé.</p>
        </Block>

        <Block title="Article 5 — Propriété intellectuelle">
          <p>L'ensemble des contenus fournis reste la propriété exclusive de SYNERGIE VITA HOLDING. La Triple Fusion™ est une marque déposée. Toute reproduction ou revente est interdite.</p>
        </Block>

        <Block title="Article 6 — Responsabilité">
          <p>Les prestations de l'Académie AETHERIS relèvent du développement personnel et ne constituent pas un avis médical, juridique ou financier.</p>
        </Block>

        <Block title="Article 7 — Données personnelles">
          <p>Voir Mentions Légales et Politique de confidentialité sur <a href="/mentions-legales" className="text-gold hover:underline">serenite-essence.fr/mentions-legales</a>.</p>
        </Block>

        <Block title="Article 8 — Litiges">
          <p>En cas de litige, une solution amiable sera recherchée en priorité. À défaut, les tribunaux de Fort-de-France (Martinique) seront compétents. Droit français applicable.</p>
        </Block>

        <Block title="Article 9 — Contact">
          <p><span className="text-white">SYNERGIE VITA HOLDING</span> — <a href="mailto:gestion.svh@serenite-essence.fr" className="text-gold hover:underline">gestion.svh@serenite-essence.fr</a></p>
          <p>55 Route de la Démarche, 97233 Schoelcher, Martinique</p>
        </Block>
      </div>
    </div>
  );
}
